import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

interface FAQ {
  question: string;
  answer: string;
  category: string;
}

const faqs: FAQ[] = [
  {
    question: 'Seanslar nasıl gerçekleşir? Online mı?',
    answer: 'Evet, tüm seanslar online olarak gerçekleşir. Zoom veya Google Meet üzerinden görüntülü görüşme şeklinde yapılır. Bu sayede dünyanın her yerinden danışmanlık alabilirsiniz. Seans öncesi size bağlantı linki gönderilir.',
    category: 'Genel'
  },
  {
    question: 'Bir seans ne kadar sürer?',
    answer: 'Seansların süresi hizmete göre değişiklik gösterir. Doğum haritası analizi gibi detaylı çalışmalar 90 dakika, spiritüel danışmanlık seansları 60 dakika, enerji şifası çalışmaları 45-60 dakika sürmektedir. Randevu alırken size özel süre bilgisi verilir.',
    category: 'Genel'
  },
  {
    question: 'Doğum haritası analizi için hangi bilgilere ihtiyacınız var?',
    answer: 'Doğum haritası analizi için doğum tarihiniz, doğum saatiniz (mümkünse dakika bilgisiyle) ve doğum yeriniz (şehir) gereklidir. Doğum saati bilgisi yoksa, yaklaşık saat aralığı ile de çalışma yapılabilir ancak sonuçlar daha genel olacaktır.',
    category: 'Astroloji'
  },
  {
    question: 'Randevumu iptal edebilir veya erteleyebilir miyim?',
    answer: 'Evet, randevunuzu iptal veya erteleme talebinizi randevu tarihinden en az 24 saat önce bildirmeniz durumunda ücretsiz olarak değiştirebilirsiniz. 24 saatten daha kısa sürede yapılan iptallerde ücret iadesi yapılmaz, ancak randevu başka bir tarihe taşınabilir.',
    category: 'Genel'
  },
  {
    question: 'Gizlilik konusunda nasıl bir yaklaşımınız var?',
    answer: 'Tüm görüşmeler tamamen gizlidir. Paylaştığınız kişisel bilgiler ve seans içerikleri kesinlikle üçüncü şahıslarla paylaşılmaz. KVKK kapsamında verileriniz korunur. Seanslar kayıt altına alınmaz.',
    category: 'Genel'
  },
  {
    question: 'Spiritüel danışmanlık nedir ve kimler için uygundur?',
    answer: 'Spiritüel danışmanlık, yaşam amacınızı keşfetme, içsel rehberliğinize bağlanma, ruhsal gelişiminizi destekleme sürecidir. Hayatında anlam arayışında olan, içsel huzur ve farkındalık kazanmak isteyen herkes için uygundur. Tıbbi veya psikolojik tedavi yerine geçmez.',
    category: 'Spiritüel'
  },
  {
    question: 'Enerji şifası nasıl çalışır? Uzaktan etkili olur mu?',
    answer: 'Enerji şifası, evrensel yaşam enerjisinin yönlendirilmesiyle bedenin, zihnin ve ruhun dengelenmesini destekler. Enerji fiziksel mesafeyle sınırlı olmadığı için uzaktan şifa seansları da yüz yüze seanslar kadar etkilidir. Seans sırasında rahat bir ortamda olmanız yeterlidir.',
    category: 'Enerji'
  },
  {
    question: 'Sinastri analizi nedir? İlişkimiz için nasıl faydalı olur?',
    answer: 'Sinastri, iki kişinin doğum haritalarının karşılaştırılmasıdır. İlişkinizdeki güçlü yönleri, zorlukları, uyum alanlarını ve büyüme potansiyelini ortaya koyar. Romantik ilişkiler, iş ortaklıkları veya aile ilişkileri için uygulanabilir.',
    category: 'Astroloji'
  },
  {
    question: 'Eğitimlere katılmak için ön bilgi gerekli mi?',
    answer: 'Başlangıç seviyesi eğitimler için herhangi bir ön bilgi gerekmez. İleri seviye eğitimler için temel astroloji bilgisine sahip olmanız önerilir. Her eğitimin detay sayfasında seviye bilgisi ve ön koşullar belirtilmiştir.',
    category: 'Eğitim'
  },
  {
    question: 'Danışmanlık hizmetleriniz tıbbi tedavi yerine geçer mi?',
    answer: 'Hayır, sunduğumuz hizmetler tıbbi, psikolojik veya hukuki danışmanlık yerine geçmez. Astrolojik danışmanlık, spiritüel rehberlik ve enerji çalışmaları, kişisel gelişim ve farkındalık amaçlıdır. Ciddi sağlık sorunları için mutlaka bir sağlık profesyoneline başvurmalısınız.',
    category: 'Genel'
  },
  {
    question: 'Yıllık öngörü (transit) analizi ne zaman yaptırmalıyım?',
    answer: 'Yıllık öngörü analizini doğum gününüze yakın bir zamanda yaptırmanız idealdir. Böylece önünüzdeki yılın enerji haritasını görebilir, fırsatları ve zorlukları önceden değerlendirebilirsiniz. Ancak yılın herhangi bir zamanında da yaptırabilirsiniz.',
    category: 'Astroloji'
  },
  {
    question: 'Seanslar kayıt altına alınıyor mu?',
    answer: 'Hayır, gizlilik politikamız gereği hiçbir seans kayıt altına alınmaz. Ancak isterseniz kendi cihazınızla not alabilir veya kayıt yapabilirsiniz. Doğum haritası analizi gibi detaylı çalışmalarda size yazılı rapor sunulur.',
    category: 'Genel'
  },
  {
    question: 'Ödeme nasıl yapılır? Hangi yöntemler kabul edilir?',
    answer: 'Ödeme, randevu onaylandıktan sonra banka havalesi veya kredi kartı ile yapılabilir. Ödeme bilgileri randevu onayı ile birlikte size iletilir. Ödeme yapıldıktan sonra seans linki gönderilir.',
    category: 'Genel'
  },
  {
    question: 'Eğitimler canlı mı yoksa kayıttan mı izlenir?',
    answer: 'Eğitimler canlı online olarak gerçekleşir ve etkileşimlidir. Katılamadığınız dersler için kayıt sunulur. Böylece hem canlı derslere katılıp soru sorabilir, hem de kaçırdığınız dersleri izleyebilirsiniz.',
    category: 'Eğitim'
  },
  {
    question: 'İlk kez danışmanlık alacağım, nereden başlamalıyım?',
    answer: 'İlk kez danışmanlık alacaksanız, doğum haritası analizi ile başlamanızı öneririz. Bu, kendinizi daha iyi tanımanızı sağlar. Alternatif olarak, ücretsiz ön görüşme talep edebilir, ihtiyacınıza en uygun hizmeti birlikte belirleyebiliriz.',
    category: 'Genel'
  }
];

const categories = ['Tümü', 'Genel', 'Astroloji', 'Spiritüel', 'Enerji', 'Eğitim'];

export default function SSSPage() {
  const [selectedCategory, setSelectedCategory] = useState('Tümü');
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const filteredFAQs = selectedCategory === 'Tümü'
    ? faqs
    : faqs.filter(faq => faq.category === selectedCategory);

  return (
    <div className="min-h-screen bg-gradient-to-b from-cream to-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-navy/5 to-gold/5"></div>
        <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="font-serif text-5xl md:text-6xl font-bold text-primary-dark mb-6">
              Sıkça Sorulan Sorular
            </h1>
            <p className="text-lg text-text-secondary leading-relaxed">
              Hizmetlerimiz, seanslar ve süreçler hakkında merak ettiğiniz her şey. 
              Cevabını bulamadığınız sorular için bizimle iletişime geçin.
            </p>
          </div>

          {/* Category Filter */}
          <div className="flex flex-wrap items-center justify-center gap-3 mt-12">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => {
                  setSelectedCategory(category);
                  setOpenIndex(null);
                }}
                className={`px-6 py-2.5 rounded-full text-sm font-medium transition-all duration-300 cursor-pointer whitespace-nowrap ${
                  selectedCategory === category
                    ? 'bg-gold text-primary-dark shadow-lg shadow-gold/30'
                    : 'bg-white text-text-secondary border border-gold/30 hover:border-gold'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Accordion */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <div className="space-y-4">
            {filteredFAQs.map((faq, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl shadow-lg overflow-hidden transition-all duration-300"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gold/5 transition-colors duration-300 cursor-pointer"
                >
                  <div className="flex-1 pr-4">
                    <h3 className="font-serif text-lg font-bold text-primary-dark">
                      {faq.question}
                    </h3>
                  </div>
                  <div className={`w-8 h-8 rounded-full bg-gold/10 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}>
                    <i className="ri-arrow-down-s-line text-gold text-xl"></i>
                  </div>
                </button>
                
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === index ? 'max-h-96' : 'max-h-0'
                  }`}
                >
                  <div className="px-6 pb-5">
                    <p className="text-text-secondary leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-primary-navy to-primary-dark">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <div className="w-16 h-16 bg-gold/20 rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-question-line text-3xl text-gold"></i>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mb-6">
            Başka Sorularınız mı Var?
          </h2>
          <p className="text-lg text-text-light mb-8 leading-relaxed">
            Cevabını bulamadığınız sorular için bizimle iletişime geçin. 
            Size yardımcı olmaktan mutluluk duyarız.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/iletisim"
              className="px-8 py-4 bg-gold text-primary-dark rounded-full font-medium hover:shadow-lg hover:shadow-gold/50 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              İletişime Geç
            </Link>
            <a
              href="https://wa.me/905555555555"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="px-8 py-4 bg-white/10 text-white border border-white/30 rounded-full font-medium hover:bg-white/20 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              WhatsApp
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}